import { UserJobInformation } from "../entities/User";
import { ApiService } from "./ApiService";

export class UserService {
    private readonly apiService: ApiService;

    constructor(apiService: ApiService) {
        this.apiService = apiService;
    }

    public async getJobInfo(): Promise<UserJobInformation> {
        return await this.apiService.getNoOrg("user/jobInfo");
    }
}
